export function withShortcuts(editor, keywordActionsConfig?: any) {
  const { onKeyDown } = editor

  editor.onKeyDown = (editor, event) => {
    if (onKeyDown) {
      onKeyDown(editor, event)
    }
  }

  return editor
}
